import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("line", {
      x1: "0.875",
      y1: "-0.875",
      x2: "24.5649",
      y2: "-0.875",
      transform: "matrix(0.707556 0.706657 -0.666094 0.745868 0.0537109 2.02344)",
      stroke: "#AA1E2D",
      "stroke-width": "1.75",
      "stroke-linecap": "square"
    }, null, -1),
    _createElementVNode("path", {
      d: "M18.0537 2L9.8715 10.1718L1.68929 18.3436",
      stroke: "#AA1E2D",
      "stroke-width": "1.75",
      "stroke-linecap": "square"
    }, null, -1)
  ]))]))
}
export default { render: render }